// extracted by mini-css-extract-plugin
module.exports = {"subregionTextBoxHeader":"styles_subregionTextBoxHeader__-1tjd","subregionTextBoxDescription":"styles_subregionTextBoxDescription__2Rs7B"};